import { useEffect, useRef } from 'react';

const usePrevious = <T extends unknown>(value: T): T | undefined => {
  const reference = useRef<T>();

  useEffect(() => {
    reference.current = value;
  });

  return reference.current;
};

export default usePrevious;
